import React from 'react';
import ua from '@tencent/docs-user-agent';
import { getAidForReport } from '@tencent/txdocs-aid';
import { tdwWithVip } from '@src/js/common/ark-extensions/dc-components/vip-linktext';
import i18n from '@i18next/i18n';
import { openPay } from '@src/js/common/ark-extensions/dc-components/pay';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { RUNTIME } from '@src/slide/infrastructure/module/dependent/config/tob/constant';

import Snackbar from '@tencent/dui/lib/components/Snackbar';

import './index.less';
import { VipTabType } from '@src/js/common/ark-extensions/dc-components/avatar-nick-nameplate/type';
import { openUrlForAll } from '@src/slide/infrastructure/module/independent/url/open-url';

export function getReportPosition() {
    const position = ua.isMobile ? 'mobile_titlebar' : 'pc_titlebar';
    return position;
}
/**
 * 展示提示信息
 * @param isOpen 是否已开启隐身查看
 */
export function showTips(isOpen: boolean, type: 'INIT' | 'NEXT') {
    Snackbar.show?.({
        type: 'success',
        icon: <div className="anonymous-view-vip-icon"></div>,
        message: isOpen
            ? type === 'INIT'
                ? i18n.t('正在隐身查看当前文档')
                : i18n.t('已开启隐身查看')
            : i18n.t('已取消隐身查看'),
        style: {
            zIndex: 10003,
        },
        autoClose: true,
        closable: false,
        duration: 3000,
    });
    tdwWithVip({
        module: 'tips',
        opername: 'doc_vip_invisible',
        action: 'show',
        ver7: isOpen ? (type === 'INIT' ? i18n.t('重新进入查看') : i18n.t('已开启')) : i18n.t('已取消'),
        ver9: getReportPosition(),
    });
}

export function showWhenSVipExpired() {
    // 每个文档只弹出一次, 需要设置 flag
    const padId = SlideDataServices.DocInfoManager()?.padId ?? '';
    const userId = SlideDataServices.DocInfoManager()?.userId ?? '';

    const key = `anonymous_${padId}_${userId}`;
    const tipsFlag = localStorage.getItem(key);
    if (tipsFlag) {
        return;
    }

    Snackbar.show({
        icon: <div className="anonymous-view-vip-icon"></div>,
        message: i18n.t('会员已过期, 隐身查看已失效'),
        type: 'info',
        duration: 3000,
        autoClose: true,
        closable: false,
        action: <span style={{ color: '#db8f1c' }}>{i18n.t('开通会员')}</span>,
        onClickAction: () => {
            if (ua.isMobile) {
                showMobileVipModal();
            } else {
                showVipModal();
            }
        },
    });

    // 过期上报
    tdwWithVip({
        module: 'entrance',
        opername: 'doc_vip_invisible',
        action: 'show',
        ver9: ua.isMobile ? 'mobile_overduetips' : 'pc_overduetips',
    });
    localStorage.setItem(key, '1');
}

function showMobileVipModal() {
    // 过期上报
    tdwWithVip({
        module: 'entrance',
        opername: 'doc_vip_invisible',
        action: 'click',
        ver9: 'mobile_overduetips',
    });

    const aid = getAidForReport({
        feature: 'invisible',
        position: 'overduetips',
        apprec1: 'slide',
    });
    openUrlForAll({
        url: `https://${RUNTIME.DOMAIN_NAME}/vip/h5-pay?aid=${aid})}&vipTabType=${VipTabType.JUST_SUPER_VIP}`,
    });
}

async function showVipModal() {
    const aid = getAidForReport({
        feature: 'invisible',
        position: 'overduetips',
        apprec1: 'slide',
    });
    openPay(aid, undefined, {
        onSuccess: () => {
            // 过期上报
            tdwWithVip({
                module: 'entrance',
                opername: 'doc_vip_invisible',
                action: 'click',
                ver9: 'pc_overduetips',
            });
        },
        extParam: {
            vipTabType: VipTabType.JUST_SUPER_VIP,
        },
    });
}
